import React from 'react';


export default ({color, onClick, size}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size || 15} height={size || 15} viewBox="0 0 15 15">
      <path fill={color || '#0092e5'} d="M2214.6,863.081l-1.756-1.759a2.147,2.147,0,0,0-2.966,0l-8.123,8.134a.811.811,0,0,0-.223.394l-1.288,4.814a.844.844,0,0,0,.814,1.063.837.837,0,0,0,.218-.029l4.822-1.293a.828.828,0,0,0,.386-.227l8.117-8.128a2.1,2.1,0,0,0,0-2.969Zm-2.949-.565,1.757,1.759a.412.412,0,0,1,0,.581l-.756.757-2.337-2.34.755-.757A.416.416,0,0,1,2211.656,862.517Zm-9.4,11.173.856-3.2,6.016-6.024,2.337,2.34-6.017,6.025Z" transform="translate(-2200.219 -860.728)"/></svg>
  )
}